var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.05,52.572H20.74a.357.357,0,0,0-.345.368V66.2a.357.357,0,0,0,.345.368H40.05A.357.357,0,0,0,40.4,66.2V52.94A.357.357,0,0,0,40.05,52.572Z",
    transform: "translate(-20.395 -52.572)",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.522,66.483,40.261,52.66a.327.327,0,0,0-.218-.089H20.74a.357.357,0,0,0-.345.368V66.2A.372.372,0,0,0,20.522,66.483Z",
    transform: "translate(-20.395 -52.571)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.625,52.572H20.757a.362.362,0,0,0-.362.362v5.685Z",
    transform: "translate(-20.395 -52.572)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5,123.263a2.535,2.535,0,0,0-2.128-2.128l-.378-.756-.378.756a2.535,2.535,0,0,0-2.128,2.128l-.756.378.756.378a2.535,2.535,0,0,0,2.128,2.128l.378.756.378-.756a2.535,2.535,0,0,0,2.128-2.128l.756-.378Zm-2.506,2.553a2.175,2.175,0,1,1,2.175-2.175A2.175,2.175,0,0,1,82.99,125.816Z",
    transform: "translate(-77.191 -117.389)",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.991,164.07l.39.718.817-.021-.427.7.427.7-.817-.021-.39.718-.39-.718-.817.021.427-.7-.427-.7.817.021Z",
    transform: "translate(-123.444 -159.204)",
    fill: "#ff4b55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonaire);
export default __webpack_public_path__ + "static/media/bonaire.cbd968f95cbf8f75c210b830afffc56e.svg";
export { ForwardRef as ReactComponent };